<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
// import Info from "./info.vue";
// import Check from "./check.vue";
// import Track from './track.vue'
export default {
  extends: baseList,
  components: {
    // info: Info,
    // Repair,
    // Track,
    // Check,
  },
  data() {
    return {
      table: {
        mname: "inventoryRecord",
        key: "id",
        url: {
          list: "/admin/system/facilityCheck/list",
        },
        output: false,
        order: "createTime",
      },
      query: {
      },
      actions: [
      ],
      menus: [
        {
          label: "盘点纪录",
          name: "inventory_record_list",
          auth: "system/inventoryRecordList/index",
        },
        {
          label: "主动巡检",
          name: "active_inspection_list",
          auth: "system/activeInspectionList/index",
        },
        {
          label: "定时巡检",
          name: "inspection_list",
          auth: "system/inspection/index",
        },
      ],
      filters: [
        {
          label: "盘点人",
          KeyEnter: this.search,
          name: "createBy",
          value: "",
          type: "input",
        },
        // {
        //   label: "负责人",
        //   KeyEnter: this.search,
        //   name: "maintainerId",
        //   value: "",
        //   type: "select",
        //   dropList: [],
        // },
        {
          label: "盘点时间",
          KeyEnter: this.search,
          name: "",
          value: "",
          type: "contractdatetimerange",
        },
        {
          label: "资产编号",
          name: "facilityNo",
          KeyEnter: this.search,
          value: "",
          type: "input",
        },
        {
          label: "资产名称",
          name: "facilityName",
          type: "input",
          KeyEnter: this.search,
          value: "",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "资产编号",
          key: "facilityNo",
          width: 120,
          align: "center",
        },
        {
          title: "资产名称",
          key: "facilityName",
          width: 200,
          align: "left",
        },
        {
          title: "盘点信息",
          key: "content",
          minWidth: 280,
          align: "left",
        },
        {
          title: "盘点人",
          key: "createBy",
          width: 120,
          align: "center",
        },
        {
          title: "盘点凭证",
          width: 120,
          align: "center",
          key: "imgUrl",
          viewimage: true,
        },
        {
          title: "盘点时间",
          key: "createTime",
          width: 120,
          align: "center",
        },
      ],
    };
  },
  created() {
    this.loaduserData();
  },
  methods: {
    //查询维修员
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.filters[index]["dropList"] = (
                this.filters[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    toCheck(row) {
      //   this.$Modal.success({
      //     closable: true,
      //     title: "巡检记录",
      //     width: "1000px",
      //     okText: "取消",
      //     showOk: false,
      //     render: (h) => {
      //       return (
      //         <Check
      //           style={{ margin: "0", color: "#19be6b" }}
      //           planId={row.id}
      //         ></Check>
      //       );
      //     },
      //   });
    },
    toAdd() {
      $utils.url.push({ name: "inspection_add", query: { action: "add" } });
    },
    //  handleEdit(currentRow){
    //   $utils.url.push({ name: "inspection_edit", query: {action: "edit", kv: currentRow.id } });
    // },
    //详情
    toinfo(row) {
      $utils.url.push({
        name: "inspection_info",
        query: { action: "edit", kv: row.id, planId: row.id },
      });
    },
    // //导出
    // toImport() {},
    // //下载模板
    // toDownload() {},
  },
};
</script>
<style scoped></style>
